module.exports = __webpack_public_path__ + "img/bongo.a110b854.png";